import axios from 'axios';
import {ModelFactory} from '@danhoss/model/factory'

export class CartHttpClient {
    async getData() {
        const url = `/app/cart.php?action=get_cart`;
        const {data} = await axios.get(url);

        const factory = new ModelFactory();

        return factory.createModel('CartModel', data);
    }

    async removeItemByIndex(index) {
        const url = `/app/cart.php?action=remove&index=${index}`;
        const {data} = await axios.get(url);

        const factory = new ModelFactory();

        return factory.createModel('CartModel', data);
    }

    async changeQuantity(indexId,quantity) {
        const url = `/app/cart.php?action=quantity`;
        const {data} = await axios.post(url, {
            index: indexId,
            quantity: quantity,
        });

        const factory = new ModelFactory();

        return factory.createModel('CartModel', data);
    }
}
